import apiClient from "utils/apiClient";

const BASE = "/ovizia-service/api/v1/admin/generation-attempts";

// Spring rejects an empty string for an enum @RequestParam (e.g. status=""),
// so strip blanks instead of sending them.
function cleanParams(params) {
  return Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== "" && v !== null && v !== undefined),
  );
}

export async function fetchGenerationAttempts({ query = "", status = "", template = "", page = 0, size = 50 } = {}) {
  const { data } = await apiClient.get(BASE, { params: cleanParams({ query, status, template, page, size }) });
  return data.content; // Spring Page<T> — callers only ever consumed the array
}

export async function fetchGenerationAttempt(id) {
  const { data } = await apiClient.get(`${BASE}/${id}`);
  return data;
}

export async function fetchTemplateNames() {
  const { data } = await apiClient.get(`${BASE}/templates`);
  return data;
}

// New — not in the mock. Replaces the client-side counting the page
// currently does by fetching every attempt and filtering in JS.
// See patches/GenerationMonitoringPage.diff.md for the page-side change.
export async function fetchGenerationAttemptStats() {
  const { data } = await apiClient.get(`${BASE}/stats`);
  return data; // { running, queued, failed, completed }
}

export async function retryGeneration(attemptId) {
  const { data } = await apiClient.post(`${BASE}/${attemptId}/retry`);
  return data;
}
